import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class ContractProgramScreen extends React.Component {

    constructor(props) {
        super(props);

        var args = props.args != undefined ? props.args : {}

        var contract = ""
        var program = ""
        
        if (this.props.args.contract) {
            contract = this.props.args.contract
        }

        if (this.props.args.program) {
            program = this.props.args.program
        }

        var programid = null
        var contractid = null

        if (props.args.programid) {
            programid = props.args.programid
        }

        if (props.args.contractid) {
            contractid = props.args.contractid
        }

        this.state = {args: args, 
                      programOptions: [], 
                      contractOptions: [],  
                      currentProgram: {id: null, 
                                       programid: programid,     
                                       program: program, 
                                       contract: contract,
                                       contractid: contractid, 
                                       value: 0,
                                       contract_value: 0
                                        }};

        this.handleChangeValue = this.handleChangeValue.bind(this);  
        this.handleChangeProgram = this.handleChangeProgram.bind(this); 
        this.handleChangeContract = this.handleChangeContract.bind(this); 
        this.save = this.save.bind(this);    
        
    }

    async componentDidMount() {

        if (this.props.args.id && this.props.args.id.length > 0) {
            BaseApi.get("/contract/program", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.id}, withCredentials: true})
            .then(res => { 
                this.setState({currentProgram: res.data})
            })    
            .catch()
        }

        BaseApi.get("/programs", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const programOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({programOptions: programOptions})
        })    
        .catch()

        BaseApi.get("/contracts", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const contractOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({contractOptions: contractOptions})
        })    
        .catch()

    }


    save(event) {
        BaseApi.post('/contract/program', this.state.currentProgram, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.state.args)
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

   
    handleChangeValue(event) {
        var currentProgram = this.state.currentProgram
        currentProgram.value = event.target.value
        this.setState({currentProgram: currentProgram})      
    }
    
    handleChangeProgram(selectedOption) {
        var currentProgram = this.state.currentProgram
        currentProgram.programid = selectedOption.value
        currentProgram.program = selectedOption.label
        this.setState({currentProgram : currentProgram})
    }

    handleChangeContract(selectedOption) {
        var currentProgram = this.state.currentProgram
        currentProgram.contractid = selectedOption.value
        currentProgram.contract = selectedOption.label
        this.setState({currentProgram : currentProgram})
    }

    render() {
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Финансирование"}/>
                <div class="row mt-5">
                    <div class="col-md-6">
                        <form>
                            <div class="form-group">
                                {this.props.args.contractid &&    
                                <div>        
                                <label for="name">Контракт:</label>
                                <input type="text" class="form-control w-100" id="name" value={this.state.currentProgram.contract} readonly/>
                                <label for="program">Программа:</label>        
                                <Select options= {this.state.programOptions} 
                                        id="program" 
                                        onChange={this.handleChangeProgram}
                                        placeholder={this.state.currentProgram.program}    
                                />  
                                </div> 
                                }

                                {this.props.args.programid &&    
                                <div>        
                                <label for="name">Программа:</label>
                                <input type="text" class="form-control w-100" id="name" value={this.state.currentProgram.program} readonly/>
                                <label for="program">Контракт:</label>        
                                <Select options= {this.state.contractOptions} 
                                        id="program" 
                                        onChange={this.handleChangeContract}
                                        placeholder={this.state.currentProgram.contract}    
                                />  
                                </div> 
                                }
                                <label for="end">Сумма:</label>
                                <input type="number" class="form-control" id="value"  value={this.state.currentProgram.value} onChange={this.handleChangeValue}/>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3 offset-3">
                        <div class="row mt-3">
                            <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                        </div>
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/contract-program.js